import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssinaturaProductComponent } from './assinatura-product.component';



@NgModule({
  declarations: [
    AssinaturaProductComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    AssinaturaProductComponent
  ]
})
export class AssinaturaProductModule { }
